import { useMediaQuery } from "usehooks-ts";

export const REDUCED_MOTION_MEDIA_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Read this instead of relying on `motion-reduce:` utilities. Tailwind is
 * configured `important: true` here and its utilities sit in a cascade layer;
 * among important declarations the earlier layer wins, so `motion-reduce:`
 * never outranks the entrance classes beside it.
 */
export function useReducedMotion(): boolean {
  return useMediaQuery(REDUCED_MOTION_MEDIA_QUERY, { defaultValue: false });
}
